var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD1WashingMachine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3v70h58V3H9zm54 66H13V21h50v48zm0-52H13V7h50v10zm-4-3h-4v-4h4v4zM38 66.21a21 21 0 100-42 21 21 0 000 42zm0-38a17 17 0 110 34 17 17 0 010-34zM52 14h-4v-4h4v4zm-6.06 31.44a10.29 10.29 0 012.58-6.82 12.6 12.6 0 01.15 13.82 10.34 10.34 0 01-2.73-7zm-20.55 0a12.44 12.44 0 0121.27-8.76 12.46 12.46 0 000 17.52 12.44 12.44 0 01-21.27-8.76zM39 14H17v-4h22v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/D1_Washing_machine.948953e7.svg";
export { SvgD1WashingMachine as ReactComponent };